export default function getInteractionModelUuidFromLocation(): string | null {
  const path = window.location.pathname

  // Example: /<uuid>/...
  const m = path.match(
    /\/([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})/i
  )

  return m?.[1] ?? null
}
